import store from "../index";
import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import playerGroups from "@/services/da/player-groups.service";
import { DocumentData, DocumentSnapshot, setDoc, updateDoc } from "firebase/firestore";

@Module
class PlayerGroupsModule extends VuexModule {

    data: any = null
    groupSingleDocument: DocumentSnapshot<DocumentData> | null = null

    get item() {
        return this.groupSingleDocument != null ?
            { id: this.groupSingleDocument.ref.id, ...this.groupSingleDocument.data() } :
            null
    }

    @Action
    async load(id?: string) {

        if (typeof id != 'string') {
            const snapshot = await playerGroups.getCollectionDocs();
            if (!snapshot.empty) {
                const groups = snapshot.docs.map(d => {
                    return { id: d.ref.id, ...d.data() }
                })
                this.update(groups);
            }
        } else {
            const d = await playerGroups.getById(id);
            if (d.exists()) {
                this.updateItem(d);
            }
        }
    }

    @Action
    async updateGroupDoc(data: { [key: string]: any }) {
        if (this.groupSingleDocument != null) {
            await updateDoc(this.groupSingleDocument?.ref, data)
        }
    }

    @Mutation
    update(data: any | null) {
        this.data = data;
    }

    @Mutation
    updateItem(data: DocumentSnapshot<DocumentData> | null) {
        this.groupSingleDocument = data
    }

    @Action
    reset() {
        this.update(null)
        this.updateItem(null)
    }
}
const name = "playerGroupsModule";

export const playerGroupsModule = new PlayerGroupsModule({
    store,
    name
});
